// extracted by mini-css-extract-plugin
export var modalBase = "modal-module--modalBase--d901c";
export var modalClose = "modal-module--modalClose--97fa1";
export var modalOverlay = "modal-module--modalOverlay--c1f4a";
export var red = "modal-module--red--37f46";